var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2870_107014)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M7.55 21.75c9.055 0 14.008-7.503 14.008-14.008 0-.211-.004-.427-.014-.638A10 10 0 0 0 24 4.555c-.898.4-1.85.66-2.826.774a4.95 4.95 0 0 0 2.165-2.723A9.9 9.9 0 0 1 20.213 3.8a4.93 4.93 0 0 0-8.394 4.49A13.99 13.99 0 0 1 1.673 3.15a4.93 4.93 0 0 0 1.523 6.57 4.9 4.9 0 0 1-2.23-.614v.06a4.92 4.92 0 0 0 3.95 4.829 4.9 4.9 0 0 1-2.221.084 4.93 4.93 0 0 0 4.597 3.422A9.88 9.88 0 0 1 0 19.538a13.97 13.97 0 0 0 7.55 2.212"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2870_107014"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgTwitter;